"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toSentence = exports.toTitleCase = exports.capitalize = void 0;
var capitalize = function (str) {
    return str[0].toUpperCase() + str.substring(1);
};
exports.capitalize = capitalize;
var toTitleCase = function (str) {
    return str.split(' ').map(exports.capitalize).join(' ');
};
exports.toTitleCase = toTitleCase;
var toSentence = function (strs) {
    if (strs.length === 0)
        return '';
    if (strs.length === 1)
        return strs[0];
    return strs.reduce(function (sentence, str, idx) {
        return idx === strs.length - 1 ? "".concat(sentence, " and ").concat(str) : "".concat(sentence, ", ").concat(str);
    });
};
exports.toSentence = toSentence;
//# sourceMappingURL=strings.js.map